import React from "react";
import Flagship from "../../core/flagship";
import UserField from "../misc/UserField";
import { connect } from "react-redux";
import { Header, Grid, Modal, Button, Icon } from "semantic-ui-react";

class LineItemAssignModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onChange = this.onChange.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
    this.assigneeData = {
      first_name: this.props.data.first_name,
      last_name: this.props.data.last_name,
      id: this.props.data.user_id,
      photo: this.props.data.photo,
      username: this.props.data.username,
      email: this.props.data.email,
      phone: this.props.data.phone
    };
  }

  getInitialState() {
    return {
      assignee: this.props.data.user_id,
      assigneeName: this.props.data.first_name + " " + this.props.data.last_name
    };
  }

  onChange(e, data) {
    let assigneeName = "";

    if (typeof data.options !== "undefined" && data.options.length > 0) {
      data.options.map(function(item) {
        if (item.value === data.value) {
          assigneeName = item.text;
        }
      });

      this.setState({
        assignee: data.value,
        assigneeName
      });
    }
  }

  saveAndExit() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;
    Flagship.post(
      "line-item/assign/" + self.props.data.id,
      {
        assignee: this.state.assignee,
        assignedName: this.state.assignedName
      },
      function(response) {
        if (response.data.success === true) {
          Flagship.sendMail(
            "update-line-item-assignee",
            {
              lineItemId: self.props.data.id,
              lineItemKey: self.props.data.line_item_key,
              lineItemName: self.props.data.line_item_name,
              oldAssignee: self.props.data.user_id,
              newAssignee: self.state.assignee
            },
            self.props.recordId,
            self.props.userId
          );

          Flagship.event(
            "update-line-item-assignment",
            {
              lineItemId: self.props.data.id,
              lineItemKey: self.props.data.line_item_key,
              lineItemName: self.props.data.line_item_name,
              oldAssignee: self.props.data.user_id,
              newAssignee: self.state.assignee
            },
            self.props.recordId,
            self.props.userId
          );

          Flagship.notify("Line item assigned.");
          self.setState(self.getInitialState(), function() {
            // Subscribe user to parent RFP
            Flagship.post(
              "subscribe/" +
                self.props.data.parent_rfp +
                "/" +
                response.data.user_id,
              {},
              function(response) {
                if (response.data.success === true) {
                  self.props.onChangeAssignee();
                  Flagship.notify(
                    "Subscribed new assignee to parent RFP.",
                    "info"
                  );
                } else {
                  Flagship.error(
                    "Failed to add as a subscriber.",
                    self.props.data.id,
                    self.state.assignee
                  );
                }
              }
            );

            if (typeof self.props.onUpdateLineItem === "function") {
              self.props.onUpdateLineItem();
            }
          });
        } else {
          Flagship.error(
            "Error updating line item assignee.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Error updating line item assignee: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  render() {
    let self = this;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.cancelUpdate}
        closeIcon
        closeOnDimmerClick={false}
      >
        <Header
          icon="pin"
          content={
            this.props.data.line_item_key +
            " - " +
            this.props.data.line_item_name
          }
        />
        <Modal.Content>
          <div>
            <Grid>
              <Grid.Column width={16}>
                <UserField
                  label="Assigned User"
                  userData={this.assigneeData}
                  selectedUser={this.state.assignee}
                  onChange={(e, data) => self.onChange(e, data)}
                />
              </Grid.Column>
            </Grid>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.saveAndExit}>
            <Icon name="plus" /> Update Line Item
          </Button>
          <Button color="grey" onClick={this.props.cancelUpdate}>
            <Icon name="dont" /> Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(LineItemAssignModal);



// WEBPACK FOOTER //
// ./src/components/modals/LineItemAssignModal.js